import React from 'react';
import {Grid} from 'react-bootstrap';
import {connect} from 'react-redux';
import {getThreadDetail, postComment, deleteComment, getThreads,
  editComment, editThread, getOnlyThread} from '../actions/SupportAction';
import {Thread, CommentSection, EditThread, Description} from '../components/Forum.Thread.Components';
import '../styles/css/support.forum.thread.css';
import {commentArray} from '../util/utils';
import {edgeServer} from '../api_client/apiClient';
import {EditorState, ContentState, convertFromHTML, convertToRaw} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import uploadImageCallBack from '../util/uploadImageCallBack';
import Spinner from '../components/Spinner';
import {pageView} from '../util/tracking';

class ForumThread extends React.Component{
  constructor(props){
    super(props);
    this.state={
      commentBox: false,
      comment: '',                  // for new comment handler
      editArray: null,              // for owner comment section
      thread: this.props.thread,
      threadComments: this.props.comments,
      threadId: this.props.match.params.id,
      mode: 'read',
      isDone: false,
    };

  }

  componentWillMount(){
    let {thread, threadComments, threadId} = this.state;

    if(!thread || threadId!==thread.id){
      this.props.getThreadDetail(threadId);
    }else{
      this.setState({
        isDone: true,
        editArray : commentArray(threadComments, this.props.userId)
      });
    }
    pageView();
  }

  componentWillReceiveProps(nextProps){
    let {userId} = this.props;

    if(nextProps.error){
      alert(nextProps.error);
      this.props.history.push('/forum');
    } else{
      if(this.state.thread !==nextProps.thread){
        // calculating how many comments are owned by the current logged in user
        // let array = commentArray(nextProps.comments)
        this.setState({
          isDone: true,
          thread : nextProps.thread,
          threadComments: nextProps.comments,
          editArray : commentArray(nextProps.comments, userId)
        });
      }else{
        if(this.props.comments !== nextProps.comments){
          this.setState({
            threadComments: nextProps.comments,
            editArray: commentArray(nextProps.comments, userId)
          })
          this.onReplyCancelClick();
          let commentNode = this.state.commentNode;
          if(commentNode){
            commentNode.style = "visibility:visible";
            this.setState({
              commentNode : null
            })
          }
        }
      }
      if(nextProps.editStatus){
        // PROBABLY SHOULD SEPARATE GET THREAD AND GET COMMENT
        this.props.getOnlyThread(this.state.threadId);
        // FORUM TRHEADS LIST NEEDS TO BE UPDATED AROUND THIS POINT TOO
        this.onThreadEditCancel();

      }
    }
  }

  onReplyBtnClick(evt){
    evt.preventDefault();
    this.setState({
      commentBox: true
    });
  }

  onReplyCancelClick(){
    this.setState({
      commentBox: false,
      comment: ''
    });
  }

  handleChange(evt){
    this.setState({
      comment: evt.target.value
    });
  }

  onReplySubmit(){
    let comment = {
      comment: {
        contents: this.state.comment,
      }
    }
    this.props.postComment(comment, this.state.threadId);
  }

  onThreadEditClick(){
    let editorState = EditorState.createWithContent(
      ContentState.createFromBlockArray(
        convertFromHTML(this.state.thread.contents)
      )
    );

    this.setState({
      mode: 'edit',
      editThread: {
        name: this.state.thread.name,
        author: this.state.thread.author,
        // category: this.state.thread.category,
        contents: editorState
      }
    })
  }

  onThreadEditChange(event){
    let editThread = this.state.editThread;
    editThread[event.target.name]=event.target.value;
    this.setState({
      editThread
    })
  }

  onEditorStateChange(editorState){
    let editThread = this.state.editThread;
    editThread['contents'] = editorState;
    this.setState({
      editThread
    })
  }

  onThreadEditSubmit(){
    let editedThread = this.state.editThread;
    let rawContents = convertToRaw(editedThread['contents'].getCurrentContent());
    let contents = draftToHtml(rawContents);
    let contentsTest = rawContents.blocks.filter(val=>val.text.length>0);

    if(!editedThread['name']){
      alert('タイトルを入力してください');
      return;
    }else if(contentsTest.length===0){
      alert('内容を入力してください');
      return;
    }

    let thread = {
      thread: {
        name: editedThread['name'],
        contents: contents
      }
    };

    if(editedThread['author']){
      thread.thread.author = editedThread['author'];
    }

    this.props.editThread(thread, this.state.threadId);
  }

  onThreadEditCancel(){
    this.setState({
      mode:'read',
      editThread: null
    })
  }

  onThreadDelete(){
    if(window.confirm("スレッドを削除しますか？")===true){
      // this.props.deleteThread(this.state.threadId);

      edgeServer.delete(`console/forum/threads/${this.state.threadId}`)
      .then((res)=>{
        this.props.getThreads(this.props.token);
        alert("このスレッドは削除されました");

        this.props.history.push('/forum');
      }).catch((err)=>{
        alert("エラーが発生しました。しばらくしてからもう一度お試しください。");
      })
    }else{
      //
    }
  }

  onCommentDeleteClick(commentId){
    if (window.confirm("返信を削除しますか？") === true) {
      this.props.deleteComment(commentId, this.state.threadId);
    } else {
      // alert("canceled");
    }
  }

  onCommentEditClick(id, comment, event){
    let commentNode = event.currentTarget.parentNode.parentNode.parentNode;
    this.setState({commentNode: commentNode})
    commentNode.style='visibility:hidden';

    let {editArray}= this.state;
    editArray.status[id] = false;
    editArray.comment[id] = comment;

    this.setState({
      edittingText: comment,
      editArray
    });
  }

  onCommentEditSubmit(commentId,event){
    let editedComment ={
      comment: {
        contents: this.state.editArray.comment[commentId]
      }
    }
    this.props.editComment(editedComment, commentId, this.state.threadId);
    // let commentNode = event.currentTarget.parentNode.parentNode.nextSibling;
    //
    // this.setState({
    //   editingComment : commentNode
    // })
    // commentNode.style="visibility:visible";
  }

  onCommentEditChange(id, event){
     let {editArray} = this.state;
     editArray.comment[id] = event.target.value;
     this.setState({
       editArray
     });
   }

  onEditCancel(id, event){
    let commentNode = event.currentTarget.parentNode.parentNode.nextSibling;
    commentNode.style="visibility:visible";
    let {editArray} = this.state;
    editArray.status[id] = true;
    editArray.comment[id] = '';
    this.setState({
     editArray
    });
  }

  render(){
    let threadHandlers = {
      onReplyBtnClick : this.onReplyBtnClick.bind(this),
      onReplyCancelClick : this.onReplyCancelClick.bind(this),
      handleChange : this.handleChange.bind(this),
      onReplySubmit : this.onReplySubmit.bind(this),
      onThreadEditClick: this.onThreadEditClick.bind(this),
      onThreadDelete: this.onThreadDelete.bind(this),
    };
    let threadEditHandlers = {
      onThreadEditChange: this.onThreadEditChange.bind(this),
      onThreadEditSubmit: this.onThreadEditSubmit.bind(this),
      onThreadEditCancel: this.onThreadEditCancel.bind(this),
      onEditorStateChange: this.onEditorStateChange.bind(this),
      imageHandler: uploadImageCallBack,
    }
    let commentHandlers = {
      onEditClick : this.onCommentEditClick.bind(this),
      onDeleteClick : this.onCommentDeleteClick.bind(this),
      onCommentEditChange: this.onCommentEditChange.bind(this),
      onEditCancel : this.onEditCancel.bind(this),
      onCommentEditSubmit: this.onCommentEditSubmit.bind(this),
    };
    let {thread, threadComments,mode,isDone} = this.state;

    let readMode =
    <Grid className="forum-page">
      {thread?
        <Thread handlers={threadHandlers} state={this.state}
        userId={this.props.userId}/>:null
      }
      {threadComments?
        <CommentSection handlers={commentHandlers} state={this.state}
        userId={this.props.userId}/>:null
      }
    </Grid>;

    let editMode =
    <Grid className="forum-page">
      <Description />
      <EditThread handlers={threadEditHandlers} thread={this.state.editThread}/>
    </Grid>

    return(
      isDone?
        (mode==='read'?readMode:editMode)
        :<Spinner />
    );
  }
}

const mapDispatchToProps = dispatch =>{
  return{
    getThreadDetail: (threadId) =>{
      dispatch(getThreadDetail(threadId));
    },
    editThread: (content, threadId)=>{
      dispatch(editThread(content, threadId));
    },
    postComment: (content, threadId)=>{
      dispatch(postComment(content, threadId));
    },
    deleteComment: (commentId, threadId)=>{
      dispatch(deleteComment(commentId, threadId));
    },
    editComment: (content, commentId, threadId)=>{
      dispatch(editComment(content, commentId, threadId));
    },
    getOnlyThread: (threadId)=>{
      dispatch(getOnlyThread(threadId));
    },
    getThreads: (token) =>{
      dispatch(getThreads(token));
    }
  };
};

const mapStateToProps = (state, props) =>{
  return{
    thread : state.support.thread,
    comments : state.support.threadComments,
    userId : state.auth.userId,
    error: state.support.error,
    editStatus: state.support.editStatus,
    token: state.support.token,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForumThread);



// WEBPACK FOOTER //
// ./src/containers/Forum.Thread.js